import {CardTypeEnum} from '@colonist/game-states'
import {GameModeTranslationKeyContext} from '@colonist/i18n'
import {BaseGameModeData} from '@colonist/shared-types'
import {StateCreator} from 'zustand'

export interface GameModeSlice {
    gameMode: {
        activeResourceCardTypes: CardTypeEnum[]
        activeDevelopmentAndProgressCardTypes: CardTypeEnum[]
        translationKeyContext: GameModeTranslationKeyContext
    }
}

export interface GameModeSliceProps {
    initialGameModeData: BaseGameModeData
}

export const createGameModeSlice = ({
    initialGameModeData,
}: GameModeSliceProps): StateCreator<GameModeSlice> => (set, get) => ({
    gameMode: {
        activeResourceCardTypes: initialGameModeData.activeResourceCardTypes,
        activeDevelopmentAndProgressCardTypes: initialGameModeData.activeDevelopmentCardTypes,
        translationKeyContext: initialGameModeData.translationKeyContext,
    },
})
